import React, { useEffect, useState, useRef } from "react";
import Navbar from "../components/Navbar";
import Footer from "../Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toTitleCase } from "../helper/formatCarName";
import { SkeletonCard } from "../components/SkeletonLoader";
import CarCard from "../components/CarCard";

const UnlockReq = () => {
  const [offerList, setofferList] = useState([]);
  const [deniedList, setdeniedList] = useState([]);
  const [selectId, setSelectId] = useState();
  const [userId, setUserId] = useState();
  const [rejectReason, setRejectReason] = useState(null);
  const [isProcess, setIsProcess] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const buttonRef = useRef(null);
  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };
  const storedUserPreferences = getDataFromlocalStorage("userData");

  const fetchData = async () => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/get/offer/bids",
        {
          owner_id: storedUserPreferences?.id,
        }
      );
      setofferList(response?.data?.biddings?.pends);
      setdeniedList(response?.data?.biddings?.rejected);
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    } finally {
      setPageLoading(false);
    }
  };

  const acceptRejectBid = async (id, status) => {
    setIsProcess(true);
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/status/bidding",
        {
          user_id: userId,
          bid_id: id,
          status: status,
          reason: rejectReason,
        }
      );
      if (!response?.data?.status) {
        toast.error(response?.data?.message);
      }
      setIsProcess(false);
      if (buttonRef.current) {
        buttonRef.current.click();
      }
      fetchData();
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  function formatEuroAmount(amount) {
    const parts = amount.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

  function backto() {
    window.history.back();
  }
  return (
    <>
      <Navbar />
      <div className="cl-page">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
            <div>
              <h3 className="cl-page-title">Offers</h3>
              <p className="cl-page-subtitle">Auto-denied after 7 days if not accepted</p>
            </div>
            <button onClick={backto} type="button" className="cl-btn cl-btn-outline cl-btn-sm">
              <i className="fa fa-arrow-left"></i>Back
            </button>
          </div>
          {pageLoading ? (
            <SkeletonCard count={8} />
          ) : (
            <div className="row g-3">
              {offerList?.map((car) => (
                <div
                  key={car.id}
                  className="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6"
                >
                  <CarCard
                    carData={car?.car}
                    topLeftContent={
                      <i
                        title="This is to inform the seller that it will be automatically rejected after 7 days."
                        className="fa-solid fa-info-circle text-white"
                        style={{ cursor: "pointer", fontSize: "16px", textShadow: "0 1px 3px rgba(0,0,0,0.5)" }}
                      ></i>
                    }
                    extraBodyContent={
                      <div className="mt-1 pt-1" style={{ borderTop: "1px solid #e5e7eb" }}>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <span style={{ fontSize: "11px", color: "#6b7280" }}>From</span>
                          <span className="fw-semibold text-truncate text-end" style={{ fontSize: "11px", color: "#00889c", maxWidth: "55%" }}>
                            {car.bidder.role === "dealer"
                              ? (car.bidder.dealerName || car.bidder.first_name || "Dealer")
                              : car.bidder.role === "user"
                                ? car.bidder.first_name
                                : null}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <span style={{ fontSize: "11px", color: "#6b7280" }}>Offer</span>
                          <span className="fw-bold text-truncate text-end" style={{ fontSize: "12px", color: "#00889c", maxWidth: "55%" }}>£{formatEuroAmount(car.amount)}</span>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <span style={{ fontSize: "11px", color: "#6b7280" }}>Request</span>
                          <span className="fw-semibold text-capitalize text-truncate text-end" style={{ fontSize: "10px", color: "#00889c", maxWidth: "55%" }}>{car.bid_request}</span>
                        </div>
                        <div className="d-flex gap-1 mt-1">
                          <button
                            style={{ fontSize: "10px", flex: 1, padding: "3px" }}
                            className="btn btn-sm btn-danger"
                            data-bs-toggle="modal"
                            onClick={(e) => {
                              e.preventDefault(); e.stopPropagation();
                              setSelectId(car.id);
                              setUserId(car.bidder?.id);
                            }}
                            data-bs-target="#exampleModal2"
                            disabled={car.status === "reject" || car.status === "decline"}
                          >
                            <i className="fa-solid fa-xmark me-1"></i>Deny
                          </button>
                          <button
                            style={{ fontSize: "10px", flex: 1, padding: "3px", background: "linear-gradient(135deg, #00889c, #006f80)", border: "none" }}
                            className="btn btn-sm text-white"
                            data-bs-toggle="modal"
                            onClick={(e) => {
                              e.preventDefault(); e.stopPropagation();
                              setSelectId(car.id);
                              setUserId(car.bidder?.id);
                            }}
                            data-bs-target="#exampleModal1"
                            disabled={car.status === "accept"}
                          >
                            <i className="fa-solid fa-check me-1"></i>Accept
                          </button>
                        </div>
                      </div>
                    }
                    hideFooter={true}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Reject Reason Modal */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content rounded-0">
            <div className="modal-body ">
              <div id="carouselExample" className="carousel slide">
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <img
                      src="img/slide1.png"
                      className="d-block w-100"
                      alt="..."
                    />
                  </div>
                  <div className="carousel-item">
                    <img
                      src="img/slide2.png"
                      className="d-block w-100"
                      alt="..."
                    />
                  </div>
                  <div className="carousel-item">
                    <img
                      src="img/slide3.png"
                      className="d-block w-100"
                      alt="..."
                    />
                  </div>
                </div>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#carouselExample"
                  data-bs-slide="prev"
                >
                  <i className="fa-solid fa-chevron-left"></i>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#carouselExample"
                  data-bs-slide="next"
                >
                  <i className="fa-solid fa-chevron-right"></i>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </div>
            <div className="modal-footer border-0 py-1">
              <button
                type="button"
                className="btn btn-secondary rounded-0"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Accept offer popup */}
      <div
        className="modal fade "
        id="exampleModal1"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel1"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body text-center mt-3 small_modal">
              <h5 className="">
                Are you sure you want to accept this request?
              </h5>

              {/* <h4 className='blue'>£65000</h4> */}
              <div className="d-flex justify-content-center mt-3">
                <button
                  onClick={() => acceptRejectBid(selectId, "accept")}
                  className="btn btn-primary btn-sm mx-2"
                  // data-bs-dismiss="modal"
                  disabled={isProcess}
                >
                  {isProcess ? "Processing..." : "Yes"}
                </button>
                <button
                  className="btn btn-danger btn-sm mx-2"
                  data-bs-dismiss="modal"
                >
                  No
                </button>
              </div>
            </div>
            <div className="modal-footer border-0">
              <button
                ref={buttonRef}
                className="btn btn-secondary btn-sm d-none"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Deny offer popup */}
      <div
        className="modal fade"
        id="exampleModal2"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel2"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body text-center mt-3 small_modal">
              <h5 className="">
                Are you sure you want to deny this request?
              </h5>
              <div className="form-group">
                <label className="form-label">Reason for deny:</label>
                <select
                  value={rejectReason}
                  onChange={(e) => setRejectReason(e.target.value)}
                  className="form-select form-control"
                >
                  <option value="">-- Select Reason --</option>
                  <option value="Price to Low">Price too Low</option>
                  <option value="Currently Under Offer">
                    Currently Under Offer
                  </option>
                  <option value="Not Available Anymore">
                    Not Available Anymore
                  </option>
                </select>
              </div>
              {/* <h4 className='blue'>£65000</h4> */}
              <div className="d-flex justify-content-center mt-3">
                <button
                  onClick={() => acceptRejectBid(selectId, "reject")}
                  className="btn btn-primary btn-sm mx-2"
                  data-bs-dismiss="modal"
                >
                  Yes
                </button>
                <button
                  className="btn btn-danger btn-sm mx-2"
                  data-bs-dismiss="modal"
                >
                  No
                </button>
              </div>
            </div>
            <div className="modal-footer border-0">
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <ToastContainer />
    </>
  );
};

export default UnlockReq;
